import routeReplaceSelf from '@/utils/routeReplaceSelf';
const storeApManagement = {
    path: "storeApManagement",
    name: "storeApManagement",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'apManagement',
        icon: 'HSIconfont hs-icon-ap',
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeApList',
            name: 'storeApList',
            component: routeReplaceSelf(() => import('@/views/storeApList/index.vue')),
            meta: { code: 'apManagement:apPro' },
            children: [
                {
                    path: 'storeApListDetail',
                    name: 'storeApListDetail',
                    hidden: true,
                    component: () => import('@/views/custApList/components/ApDetail.vue'),
                    meta: {
                        code: 'apManagement_apPro_config',
                        activeMenu: 'storeApList',
                    },
                },
                {
                    path: 'storeApLogDetail',
                    name: 'storeApLogDetail',
                    hidden: true,
                    component: () => import('@/views/storeApLogDetail'),
                    meta: {
                        code: 'apManagement_apPro_log',
                        activeMenu: 'storeApList',
                    },
                },
            ]
        },
        {
            path: 'storeApVersion',
            name: 'storeApVersion',
            component: routeReplaceSelf(() => import('@/views/storeApVersion/index.vue')),
            meta: {
                code: 'apManagement:version',
            },
            children: [
                {
                    path: 'storeApVersionUpload',
                    name: 'storeApVersionUpload',
                    hidden: true,
                    component: () => import('@/views/storeApVersion/components/VersionUpload.vue'),
                    meta: {
                        code: 'apManagement_version_upload',
                        activeMenu: 'storeApVersion',
                    },
                },
            ]
        },
        {
            path: 'storeApUpgradePlan',
            name: 'storeApUpgradePlan',
            component: routeReplaceSelf(() => import('@/views/storeApUpgradePlan/index.vue')),
            meta: {
                code: 'apManagement:upgradePlan',
            },
            children: [
                {
                    path: 'storeAddUpgradePlan',
                    name: 'storeAddUpgradePlan',
                    hidden: true,
                    component: () => import('@/views/storeApUpgradePlan/components/AddPlan.vue'),
                    meta: {
                        code: 'apManagement_upgradePlan_create',
                        activeMenu: 'storeApUpgradePlan',
                    },
                },
            ]
        },
        {
            path: 'storeApOperLog',
            name: 'storeApOperLog',
            component: routeReplaceSelf(() => import('@/views/storeApOperLog/index.vue')),
            meta: { code: 'apManagement:operLog' },
        }
    ]
};
export default storeApManagement;
